import React from 'react';
import clsx from 'clsx';

type BadgeVariant = 'critical' | 'medium' | 'low' | 'info' | 'neutral' | 'success';

interface BadgeProps {
  variant?: BadgeVariant;
  children: React.ReactNode;
  pulse?: boolean;
  className?: string;
}

export function Badge({ variant = 'neutral', children, pulse = false, className }: BadgeProps) {
  return (
    <span className={clsx('badge', `badge--${variant}`, pulse && 'badge--pulse', className)}>
      {children}
    </span>
  );
}
